export const users = [
  {
    id: "u1",
    name: "林小满",
    avatar: "https://readdy.ai/api/search-image?query=friendly%20young%20chinese%20woman%20portrait%20with%20warm%20smile%2C%20soft%20studio%20lighting%2C%20clean%20cream%20background%2C%20bright%20cheerful%20tone%2C%20editorial%20headshot&width=240&height=240&seq=banana-user-01&orientation=squarish",
    bio: "社区运营一枚，喜欢把生活过成小确幸。负责香蕉社区的日常话题策划，欢迎来唠嗑～",
    location: "上海",
    followers: 4820,
    following: 312,
    joinDate: "2023-04-18",
    tags: ["生活记录", "手帐", "咖啡"],
  },
  {
    id: "u2",
    name: "陈默",
    avatar: "https://readdy.ai/api/search-image?query=thoughtful%20young%20chinese%20man%20portrait%20with%20glasses%2C%20soft%20natural%20light%2C%20minimal%20cream%20background%2C%20calm%20expression%2C%20editorial%20headshot&width=240&height=240&seq=banana-user-02&orientation=squarish",
    bio: "十年后端工程师，现专注分布式系统与云原生。爱写技术长文，也爱在深夜读哲学。",
    location: "深圳",
    followers: 6310,
    following: 128,
    joinDate: "2022-11-02",
    tags: ["后端", "云原生", "技术写作"],
  },
  {
    id: "u3",
    name: "苏晴",
    avatar: "https://readdy.ai/api/search-image?query=elegant%20young%20chinese%20woman%20portrait%20with%20soft%20wavy%20hair%2C%20warm%20beige%20background%2C%20gentle%20natural%20light%2C%20editorial%20headshot&width=240&height=240&seq=banana-user-03&orientation=squarish",
    bio: "旅行摄影师，走过 34 个国家。相信最好的风景永远在路上，也藏在和你分享的那一刻。",
    location: "成都",
    followers: 15240,
    following: 486,
    joinDate: "2022-06-21",
    tags: ["旅行", "摄影", "攻略"],
  },
  {
    id: "u4",
    name: "阿哲",
    avatar: "https://readdy.ai/api/search-image?query=casual%20young%20chinese%20man%20portrait%20with%20friendly%20grin%2C%20warm%20sunlight%2C%20plain%20cream%20background%2C%20relaxed%20vibe%2C%20editorial%20headshot&width=240&height=240&seq=banana-user-04&orientation=squarish",
    bio: "数码测评爱好者，家里堆满各种新玩意儿。只说实话，不吹不黑，帮你少花冤枉钱。",
    location: "杭州",
    followers: 9860,
    following: 205,
    joinDate: "2023-01-09",
    tags: ["数码", "评测", "效率工具"],
  },
  {
    id: "u5",
    name: "王豆豆",
    avatar: "https://readdy.ai/api/search-image?query=cheerful%20young%20chinese%20woman%20portrait%20with%20short%20bob%20hair%2C%20soft%20warm%20lighting%2C%20clean%20beige%20background%2C%20bright%20friendly%20expression%2C%20editorial%20headshot&width=240&height=240&seq=banana-user-05&orientation=squarish",
    bio: "美食博主，探店 500+。会做饭也爱下馆子，最擅长把街边小馆写成让人流口水的长文。",
    location: "广州",
    followers: 11230,
    following: 640,
    joinDate: "2022-09-14",
    tags: ["美食", "探店", "食谱"],
  },
  {
    id: "u6",
    name: "周舟",
    avatar: "https://readdy.ai/api/search-image?query=calm%20young%20chinese%20man%20portrait%20with%20short%20hair%2C%20muted%20warm%20background%2C%20soft%20studio%20light%2C%20thoughtful%20expression%2C%20editorial%20headshot&width=240&height=240&seq=banana-user-06&orientation=squarish",
    bio: "职业规划师，帮过 800+ 人找到方向。相信职场不是赛道，而是一场和自己的长期对话。",
    location: "北京",
    followers: 7450,
    following: 190,
    joinDate: "2023-03-05",
    tags: ["职场", "求职", "成长"],
  },
  {
    id: "u7",
    name: "顾南",
    avatar: "https://readdy.ai/api/search-image?query=creative%20young%20chinese%20person%20portrait%20with%20soft%20features%2C%20warm%20cream%20background%2C%20natural%20light%2C%20artistic%20mood%2C%20editorial%20headshot&width=240&height=240&seq=banana-user-07&orientation=squarish",
    bio: "独立音乐人 & 影迷。白天写歌，晚上刷片，偶尔认真写点乐评和观后感。",
    location: "南京",
    followers: 3980,
    following: 421,
    joinDate: "2023-07-30",
    tags: ["音乐", "电影", "乐评"],
  },
  {
    id: "u8",
    name: "夏栀",
    avatar: "https://readdy.ai/api/search-image?query=gentle%20young%20chinese%20woman%20portrait%20with%20long%20hair%2C%20soft%20warm%20beige%20background%2C%20serene%20natural%20light%2C%20editorial%20headshot&width=240&height=240&seq=banana-user-08&orientation=squarish",
    bio: "家居手作爱好者，喜欢把家一点点变成想要的样子。分享小户型改造与绿植养护心得。",
    location: "苏州",
    followers: 5620,
    following: 268,
    joinDate: "2023-05-12",
    tags: ["家居", "手作", "绿植"],
  },
];